import React, { useState } from 'react';
import { Card, Button, Modal, Collapse, Row, Col } from 'antd';
import exercisesData from '../json/exercises.json'; // Adjust path as necessary
import { urlPlayer, urlYouTube } from '../video';

const { Panel } = Collapse;

const ExerciseList = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');

    const handleVideoOpen = (url) => {
        setVideoUrl(url);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setVideoUrl('');
    };

    return (
        <div style={{ padding: '10px' }}>
            <div className="dashboard-title">
                    ESERCIZI
                </div>
            {exercisesData.muscleGroups.map((group) => (
                <Collapse key={group.group} defaultActiveKey={[]} style={{ marginBottom: '10px' }}>
                    <Panel 
                        header={<span style={{ fontSize: '18px', fontWeight: 'bold' }}>{group.group}</span>} 
                        key={group.group}
                    >
                        <Row gutter={[8, 5]}> {/* Reduced gutter for exercises */}
                            {group.exercises.map(exercise => (
                                <Col xs={24} sm={12} md={8} lg={6} key={exercise.id}> {/* Responsive layout for different screen sizes */}
                                    <Card
                                        title={exercise.name}
                                        cover={<img alt={exercise.name} src={exercise.image} style={{ height: '150px', width: '100%', objectFit: 'contain' }} />} // Adjusted image style
                                        style={{ marginBottom: '5px', overflow: 'hidden' }} // Fixed height for smaller cards
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                                            {exercise.video && (
                                                <Button 
                                                onClick={() => handleVideoOpen(exercise.video)}
                                                className="button-no-background"
                                                style={{ marginTop: '5px', alignSelf: 'center' }}
                                            >
                                                Vedi Video Esercizio
                                            </Button>
                                            )}
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Panel>
                </Collapse>
            ))}

            <Modal
                title="Video Esercizio"
                open={isModalVisible}
                onCancel={handleModalClose}
                getContainer={document.body}
                footer={null}
                width="90%"
                style={{ top: '15vh' }}
            >
                {urlPlayer(videoUrl) ? (
                    <>
                        <iframe
                            width="100%"
                            height="400px"
                            src={urlPlayer(videoUrl)}
                            title="Video Esercizio"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                        <a
                            href={urlYouTube(videoUrl)}
                            target="_blank"
                            rel="noreferrer"
                            style={{ display: 'block', marginTop: '10px', textAlign: 'center', fontSize: '13px' }}
                        >
                            Se il video non parte, aprilo su YouTube
                        </a>
                    </>
                ) : (
                    <p style={{ textAlign: 'center', margin: '30px 0' }}>Video non disponibile.</p>
                )}
            </Modal>
        </div>
    );
};

export default ExerciseList;
